import { Chip, useDisclosure } from "@heroui/react";
import { useState, useEffect } from "react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { Requisite } from "@/api/requisites/requisites.ts";
import { EditRequisiteModal } from "../modals/requisites/editRequisitesModal";

export function FinanceRequisiteChip({
  requisiteId,
  callback,
}: {
  requisiteId: number;
  callback: (item: Requisite) => void;
}) {
  const [item, setItem] = useState<Requisite | null>(null);
  const items = useAppSelector((state) => state.handbooks.requisites);

  useEffect(() => {
    if (requisiteId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == requisiteId) || null);
    }
  }, [requisiteId, items]);

  return (
    <>
      {requisiteId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {requisiteId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={() => callback(item)}
          variant="dot"
          color="primary">
          {item?.displayName}
        </Chip>
      )}
      {requisiteId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}

export function RequisiteChip({ requisiteId }: { requisiteId: number }) {
  const [item, setItem] = useState<Requisite | null>(null);
  const items = useAppSelector((state) => state.handbooks.requisites);
  const disclosure = useDisclosure();

  useEffect(() => {
    if (requisiteId === -1) {
      setItem(null);
    } else {
      setItem(items.find((el) => el.id == requisiteId) || null);
    }
  }, [requisiteId, items]);

  return (
    <>
      <EditRequisiteModal disclosure={disclosure} requisite={item} />
      {requisiteId === -1 && (
        <Chip variant="dot" color="danger">
          удалено
        </Chip>
      )}
      {requisiteId !== -1 && item !== null && (
        <Chip
          className="cursor-pointer"
          onClick={disclosure.onOpen}
          variant="dot"
          color="primary">
          {item?.displayName}
        </Chip>
      )}
      {requisiteId !== -1 && item == null && (
        <Chip variant="dot" color="default">
          н/д
        </Chip>
      )}
    </>
  );
}
